import React from 'react';
import ReactDOM from 'react-dom/client';

import App from './App';
import reportWebVitals from './reportWebVitals';
import {SettingsProvider} from "./SettingsContext";
import {HelmetProvider} from "react-helmet-async";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
      <SettingsProvider>
          <HelmetProvider>
            <App />
          </HelmetProvider>
      </SettingsProvider>
  </React.StrictMode>
);
reportWebVitals();
